var _path, _g, _path2, _circle, _path3, _rect, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2FaEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 320,
    viewBox: "0 0 290 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.403 280.011H87.8321C73.1178 280.011 61.1895 266.349 61.1895 249.495V35.8763C61.1895 19.0223 73.1178 5.35938 87.8321 5.35938H194.403C209.117 5.35938 221.046 19.0223 221.046 35.8763V249.495C221.046 266.349 209.117 280.011 194.403 280.011Z",
    fill: "white",
    stroke: "#29315D",
    strokeWidth: 9.65574,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5062_3982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5635 231.704L49.2344 216.159L255.696 225.112L247.369 233.364L48.5635 231.704Z",
    fill: "#28305B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.422 31.5363H164.983",
    stroke: "#29315D",
    strokeWidth: 15.8535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.862,
    cy: 70.8616,
    r: 52.1231,
    fill: "#40DA9E",
    stroke: "#40DA9E",
    strokeWidth: 9.47693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.646 71.9615L227.395 80.3386L227.339 80.2845L247.077 61.3848",
    stroke: "white",
    strokeWidth: 9.47693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 154,
    width: 282,
    height: 80,
    rx: 40,
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.141 194.053C229.141 192.145 227.601 190.604 225.692 190.618C223.784 190.618 222.244 192.159 222.244 194.067C222.244 195.975 223.784 197.516 225.692 197.516C227.601 197.516 229.141 195.975 229.141 194.053",
    stroke: "white",
    strokeWidth: 22.9693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.524 194.053C172.524 192.145 170.983 190.604 169.075 190.618C167.167 190.618 165.626 192.159 165.626 194.067C165.626 195.975 167.167 197.516 169.075 197.516C170.969 197.516 172.524 195.975 172.524 194.053",
    stroke: "white",
    strokeWidth: 22.9693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.915 194.053C115.915 192.145 114.374 190.604 112.466 190.618C110.558 190.618 109.017 192.159 109.017 194.067C109.017 195.975 110.558 197.516 112.466 197.516C114.36 197.516 115.915 195.975 115.915 194.053",
    stroke: "white",
    strokeWidth: 22.9693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5164 194.053C59.5164 192.145 57.9757 190.604 56.0675 190.618C54.1592 190.618 52.6185 192.159 52.6185 194.067C52.6185 195.975 54.1592 197.516 56.0675 197.516C57.9615 197.516 59.5164 195.975 59.5164 194.053",
    stroke: "white",
    strokeWidth: 22.9693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5062_3982",
    x: 29.4695,
    y: 197.065,
    width: 245.32,
    height: 55.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.54697,
    result: "effect1_foregroundBlur_5062_3982"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FaEnabled);
export default __webpack_public_path__ + "static/media/2FAEnabled.686b8c897a2bceb5e5395bcde8ca020f.svg";
export { ForwardRef as ReactComponent };